import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { Observable, from, lastValueFrom} from "rxjs";

@Injectable()
export class RecaptchaInterceptor implements HttpInterceptor {
  constructor(private recaptchaV3Service: ReCaptchaV3Service) { }
  
  private actions: string[] = ["POST", "PUT", "DELETE"];
  private forbiddenActions: string[] = ["HEAD", "OPTIONS"];
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.debug('RECAPTCHA Interceptor Begin: ', request.url);
    return from(this.handleRecaptchaRequest(request, next));
  }
  
  async handleRecaptchaRequest(request: HttpRequest<any>, next: HttpHandler): Promise<any> {
    let permitted = this.findByActionName(request.method, this.actions);
    let forbidden = this.findByActionName(request.method, this.forbiddenActions);

    if (permitted !== undefined && forbidden === undefined) {
      console.debug('Applying RECAPTCHA token: ', request.url);

      let recaptchaAction = this.getRecaptchaAction(request.url);
      let token = await lastValueFrom(this.recaptchaV3Service.execute(recaptchaAction));
      let headers = request.headers.append("RE-CAPTCHA-TOKEN", token); // Important: Must match custom defined header name in the backend
      request = request.clone({ 
        headers: headers,
      });
    }

    return await lastValueFrom(next.handle(request));
  }

  private getRecaptchaAction(url: string): string{
    let split = url.split("/");
    let apiPosition = split.indexOf("api");

    if(apiPosition === 0 || apiPosition === split.length - 1 || apiPosition === -1){
      throw new Error("The url parameter is invalid.");
    }

    let controllerNamePos = apiPosition + 1;
    let recaptchaAction = split[controllerNamePos];
    return recaptchaAction;
  }
  
  private findByActionName(name: string, actions: string[]): string {
    return actions.find(action => action.toLocaleLowerCase() === name.toLocaleLowerCase());
  }
}
